export default __webpack_public_path__ + "static/media/Game-Button-PNG.4c77b753.webp";